import { internalAxios } from '../../utils/axios/internal';

export const getGraphData = async ({ period, type }, controller) => {
  const response = await internalAxios.get('/api/wallet/amci/graph', {
    params: { format: 'json', period, amciindextype: type },
    signal: controller?.signal,
  });
  return response.data;
};
